<template>
  <div
    v-if="initialized"
    class="d-flex">
    <!-- PC表示 -->
    <MemberSelectMenu
      :selected-member="selectedMember"
      @select-member="onSelectMember" />
    <!-- PC表示 end -->
    <!-- スマホ表示 -->
    <MobileHeader
      :selected-member="selectedMember"
      :slot-inset="isManager">
      <SelectedMemberListMenu
        :selected-member="selectedMember"
        @select-member="onSelectMember" />
    </MobileHeader>
    
    <!-- スマホ表示 end -->
    <div class="flex-grow-1 w-100 mw-100">
      <router-view :key="memberId" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import MobileHeader from '@/components/parts/MobileHeader'
import SelectedMemberListMenu from '@/components/view/SelectedMemberListMenu'
import MemberSelectMenu from '@/components/view/member_select_layout/MemberSelectMenu.vue'
export default {
  name: 'MemberSelectLayout',
  components: {
    MemberSelectMenu,
    MobileHeader,
    SelectedMemberListMenu
  },
  data() {
    return {
      initialized: false,
      selectedMember: null
    }
  },
  computed: {
    ...mapGetters('auth', ['isManager']),
    ...mapState('auth', ['user']),
    memberId() {
      return this.$route.params.id
    },
  },
  watch: {
    async memberId() {
      if (this.memberId) {
        this.fetchSelectedMemberInfo()
      }
    }
  },
  async created() {
    if (this.memberId) {
      await this.fetchSelectedMemberInfo()
    }
    this.initialized = true
  },
  methods: { 
    async fetchSelectedMemberInfo() {
      const res = await this.$axios.get(`/users/${this.memberId}/`).catch(e => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })
      this.selectedMember = res?.data
    },
    onSelectMember(member) {
      const currentPath = this.$route.path
      const replacedPath = currentPath.replace(`${this.$route.params.id}`, `${member.id}`)
      this.$router.push(replacedPath)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>